/**
 * Skill catalog categories and the agents they belong to.
 *
 * Shared by the Skill Marketplace (one tab per category) and the AG-UI chat
 * panel's skill pack (one card per category). `apiCategory` is a skill's SKILL.md
 * `metadata.category`; ListCatalog requires a category, so a skill whose category
 * is not listed here for its agent never reaches either surface, even though the
 * agent itself loads it. When an agent starts publishing skills under a category,
 * add that agent to the category's `agents` (or add the category).
 */
import type zhSkills from '../i18n/locales/zh/skills';

/** A catalog category; its description lives in the skills i18n file under `categories`. */
export type CategoryKey = keyof (typeof zhSkills)['categories'];

export interface CategoryConfig {
  label: string;
  apiCategory: CategoryKey;
  gradient: 'green' | 'yellow' | 'blue' | 'purple';
  /** Agents whose marketplace tab and chat skill pack show this category; queried only for them. */
  agents: readonly string[];
}

export const CATEGORIES: CategoryConfig[] = [
  {
    label: 'DataRetriever',
    apiCategory: 'dataretriever',
    gradient: 'blue',
    agents: ['rocky'],
  },
  {
    label: 'Hedwig',
    apiCategory: 'hedwig',
    gradient: 'purple',
    agents: ['rocky'],
  },
  {
    label: 'Cheetah',
    apiCategory: 'cheetah',
    gradient: 'green',
    agents: ['rocky'],
  },
  {
    label: 'IVT',
    apiCategory: 'ivt',
    gradient: 'yellow',
    agents: ['rocky'],
  },
  {
    label: 'Campaign Copilot',
    apiCategory: 'campaign_copilot',
    gradient: 'green',
    // DAT-9148: Campaign Copilot's skills are copied under marketing_agent.
    agents: ['campaign_copilot_agent', 'marketing_agent'],
  },
  {
    label: 'Event Insights',
    apiCategory: 'event_insights',
    gradient: 'purple',
    agents: ['marketing_agent'],
  },
];

/** The categories shown in `agent`'s marketplace, in display order. */
export function categoriesFor(agent: string): CategoryConfig[] {
  return CATEGORIES.filter((c) => c.agents.includes(agent));
}
